import { render, staticRenderFns } from "./members-box-item-skeleton.vue?vue&type=template&id=2a18dd03&"
import script from "./members-box-item-skeleton.vue?vue&type=script&lang=js&"
export * from "./members-box-item-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports